module.exports = __webpack_public_path__ + "static/media/20170501-_DSC5638-19_Small.4cb0c732.jpg";